var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_2_",
    "data-name": "edit (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.938,
    height: 23.938,
    viewBox: "0 0 23.938 23.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15562",
    "data-name": "Path 15562",
    d: "M18.62.928,6.46,13.088A4.953,4.953,0,0,0,5,16.614v1.34a1,1,0,0,0,1,1h1.34a4.953,4.953,0,0,0,3.526-1.46L23.023,5.33a3.117,3.117,0,0,0,0-4.4,3.186,3.186,0,0,0-4.4,0ZM21.613,3.92,9.452,16.08a3.012,3.012,0,0,1-2.115.876H6.995v-.342A3.012,3.012,0,0,1,7.871,14.5l12.16-12.16a1.145,1.145,0,0,1,1.582,0,1.12,1.12,0,0,1,0,1.582Z",
    transform: "translate(-0.013 0)",
    fill: "#1d2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15563",
    "data-name": "Path 15563",
    d: "M22.94,8.956a1,1,0,0,0-1,1v5.008h-3.99a2.992,2.992,0,0,0-2.992,2.992v3.99H4.987a2.992,2.992,0,0,1-2.992-2.992V4.987A2.992,2.992,0,0,1,4.987,1.995h9.018a1,1,0,0,0,0-1.995H4.987A4.993,4.993,0,0,0,0,4.987V18.951a4.993,4.993,0,0,0,4.987,4.987H16.3a4.955,4.955,0,0,0,3.527-1.46l2.649-2.651A4.955,4.955,0,0,0,23.937,16.3V9.953A1,1,0,0,0,22.94,8.956ZM18.417,21.067a2.967,2.967,0,0,1-1.461.8V17.953a1,1,0,0,1,1-1h3.915a3.008,3.008,0,0,1-.8,1.46Z",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed725e5fb863b9a1bf176ea617c95a66.svg";
export { ForwardRef as ReactComponent };